document.addEventListener('DOMContentLoaded', function () {
  // FV内のfade要素をページ読み込み時に即座に表示（スクロール不要）
  document.querySelectorAll('.season-collection > .relative .fade').forEach(function (el) {
    el.classList.add('show');
  });

  // URLパラメータでtargetが指定されている場合、全リソース読み込み後に該当要素までスクロールする
  window.addEventListener('load', function () {
    let pageUrl = new URL(window.location.href);
    let pageParams = pageUrl.searchParams;
    if (pageParams.get('target') && document.getElementById(pageParams.get('target')) != null) {
      let paramTargetElement = document.getElementById(pageParams.get('target'));
      scrollToTarget(paramTargetElement);
    }
  });

  const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
  for (let i = 0; i < smoothScrollTrigger.length; i++) {
    smoothScrollTrigger[i].addEventListener('click', (e) => {
      e.preventDefault();
      let href = smoothScrollTrigger[i].getAttribute('href');
      let clickTargetElement = document.getElementById(href.replace('#', ''));
      scrollToTarget(clickTargetElement);
    });
  }

  function scrollToTarget(targetElement) {
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.pageYOffset;
    let adjust = 252.5;
    const windowWidth = window.outerWidth;
    if (windowWidth <= 999) {
      adjust = 201.11;
    }
    const target = rect + offset - adjust;
    window.scrollTo({
      top: target,
      behavior: 'smooth',
    });
  }

  // タブ切り替えの実装
  var tabItems = document.querySelectorAll('ul.tab > li[data-target]');
  var panels = document.querySelectorAll('.event[data-id]');

  function showPanel(target) {
    panels.forEach(function (panel) {
      panel.style.display = panel.dataset.id === target ? '' : 'none';
    });
  }

  // 初期表示: URLパラメータtabで指定がある場合はそのタブ、なければtokyo
  var initialTab = new URL(window.location.href).searchParams.get('tab');
  var validTabs = Array.from(tabItems).map(function (item) {
    return item.dataset.target;
  });
  if (!initialTab || validTabs.indexOf(initialTab) === -1) {
    initialTab = 'tokyo';
  }
  tabItems.forEach(function (li) {
    li.classList.toggle('active', li.dataset.target === initialTab);
  });
  showPanel(initialTab);

  tabItems.forEach(function (item) {
    item.style.cursor = 'pointer';
    item.addEventListener('click', function () {
      tabItems.forEach(function (li) {
        li.classList.remove('active');
      });
      item.classList.add('active');
      showPanel(item.dataset.target);
    });
  });

  if (document.querySelector('.novelty-carousel.swiper') != null) {
    new Swiper('.novelty-carousel.swiper', {
      loop: true,
      slidesPerView: 1,
      autoHeight: true,
      speed: 1800,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
});
